export const typography = {
  title: {
    fontSize: 20,
    fontWeight: 950,
  },

  subtitle: {
    fontSize: 13,
    fontWeight: 700,
  },

  section: {
    fontSize: 16,
    fontWeight: 900,
  },

metric: {
  fontSize: 30,
  fontWeight: 950,
  lineHeight: 1.1,
},

  body: {
    fontSize: 14,
    fontWeight: 600,
  },

  caption: {
    fontSize: 11,
    fontWeight: 800,
  },
};